
import RcDomainMap from "../../common/RcDomainMap.js";
import TimesheetEntry from './TimesheetEntry.js';

export default class TimesheetEntryMap extends RcDomainMap {
  static MODEL_NAME = TimesheetEntry.MODEL_NAME  + "Map";
  
  constructor(domain, data) {
    super(domain, data, TimesheetEntryMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new TimesheetEntryMap(this.domain, data);
  }
  
  sortByStartTimeId() {
    return this.list().sort(function(a, b) {
      if (a.timeIdStart() < b.timeIdStart()) {
        return -1;
      }
      if (a.timeIdStart() > b.timeIdStart()) {
        return 1;
      }
      return 0;
    });
  }
  
  entryFor(timeId) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var entry = this.getTimesheetEntry(key);
      if (timeId >= entry.timeIdStart() && timeId <= entry.timeIdEnd()) {
        return entry;
      }
    }
    return new TimesheetEntry(this.domain);
  }
  
  find() {
    var keys = this.keys();
    var found = new TimesheetEntryMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.timesheets().entries().findById(key);
      var item = new TimesheetEntry(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getTimesheetEntry(key);
      values.push(item);
    }
    return values;
  }
  
  getTimesheetEntry(key) {
    var value = super.get(key);
    return new TimesheetEntry(this.domain, value);
  }
}